/* 🤖 this file was generated by svg-to-ts */
export const emperorIconArrowDropDown: {
  name: 'arrow_drop_down';
  data: string;
} = {
  name: 'arrow_drop_down',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M7 10l5 5 5-5Z"/></svg>`
};
